import { ApplicationActionType } from '../../../ApplicationConstants';
import { performCellDoubleClick } from './onCellDblClick';

export const onCellDblClickAppraisalOrder = (e) => {
    performCellDoubleClick(e, ApplicationActionType.AppraisalOrder);
};
